import defaultClient from '@/plugins/axios/defaultClient'
import relayV2Client from '@/plugins/axios/relayV2Client'
import qs from 'query-string'

export default {
  getBnplPayments(query) {
    return defaultClient.get(`/bnpl/payments?${qs.stringify(query)}`)
  },
  postBnplPayments(payments) {
    // v2 로 호출
    return relayV2Client.post(`/payments`, payments)
    // return defaultClient.post(`/bnpl/payments`, payments)
  },
  patchBnplPayments(payments) {
    return defaultClient.patch(`/bnpl/payments/${payments.uuid}`, payments)
  },
  deleteBnplPayments(uuid) {
    return defaultClient.delete(`/bnpl/payments/${uuid}`)
  },
  getBnplPaymentsDetail(uuid) {
    return defaultClient.get(`/bnpl/payments/${uuid}`)
  },
  getBnplAvailable() {
    return defaultClient.get(`/bnpl/available`)
  },
  getTotalAmount() {
    return defaultClient.get('/bnpl/summary/total')
  },
  /**
   * 정산 일별 조회
   * @param {
   * {
   *  startDate: 2022-11-01
   *  endDate: 2022-11-11
   * }
   * } query
   * @returns
   */
  async getSummary(query) {
    return defaultClient.get(`/bnpl/summary?${qs.stringify(query)}`)
  },
  async getLimitDate() {
    return defaultClient.get('/bnpl/summary/limit-date')
  },
  async getPreLimit(preLimit) {
    return defaultClient.post('bnpl/pre-limit', preLimit)
  },
}
